var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Breadcrumb',{attrs:{"bgcolor":"#fff"}}),_c('div',{staticClass:"user-content"},[_c('div',{staticClass:"content-left"},[_c('UserMenu')],1),_c('div',{staticClass:"content-right"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }